/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {InitiateCashOutRequest} from '@cash-web/protos/squareup/cash/out/api/v2_0/InitiateCashOutAction.pb'
import {InitiateCashOutResponse} from '@cash-web/protos/squareup/cash/out/api/v2_0/InitiateCashOutAction.pb'


export const initiateCashOut = (request:InitiateCashOutRequest, options?: CashRequestOptions) => post<InitiateCashOutRequest, InitiateCashOutResponse>("/2.0/cash/initiate-cash-out", request, {...options, rejectOnError: true })